/* Terrasul — botão "Comprar" dos cards: adiciona ao carrinho e abre a gaveta do carrinho. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ts-add]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    var notif = document.querySelector('cart-notification');
    var cart = drawer || notif;
    if (!cart || !window.fetch) return; // sem gaveta: envio normal para /cart
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.classList.add('is-loading');
    var body = new FormData(form);
    body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    body.append('sections_url', window.location.pathname);
    fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { form.submit(); return; }
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        cart.renderContents(res);
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();
